import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as yup from "yup";
import { toast } from "react-toastify";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import {
  Button,
  Col,
  Form,
  Row,
  Stack,
  Container,
  Card,
  Spinner,
} from "react-bootstrap";
import InfoIcon from "../../../assets/images/info-squar.svg";
import Swal from "sweetalert2";
import EditIcon from "../../../assets/images/Edit-icon.svg";
import DeleteIcon from "../../../assets/images/Delete-icon.svg";
import InspectionArrow from "../../../assets/images/inspection-arrow.svg";
import { getDeficiencyMachineAPI } from "../../../services/inspectionRequest";
import {
  getDeficiencyDataAPI,
  deficiencyIssueDocumentAPI,
  deficiencyCorrectionDate,
} from "../../../services/deficiency";
import {
  InspectionData,
  DeficiencyInterface,
  FormDataInterface,
} from "./interface";
import moment from "moment";

import ImageTag from "../../../components/common/ImageTag";
import InputTextArea from "../../../components/common/TextArea";
import { Formik } from "formik";
import InputText from "../../../components/common/InputText";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import InputDatePicker from "components/common/InputDatePicker";
import Loader from "../../../components/common/Loader";
import Signature from "./signature";
import { buttonColor } from "constants/constants";
export const DeficiencyReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [btnLoading, setBtnLoading] = useState(false);
  const deficiencyTitle = "deficiency";
  const recommendationTitle = "recommendation";
  const [loading, setLoading] = useState(true);
  const [showDeficiency, setShowDeficiency] = useState(false);
  const [changesState, setChangesState] = useState(false);
  const [deficiencyDataObject, setDeficiencyDataObject] = useState();
  const [deficiencyType, setDeficiencyType] = useState(deficiencyTitle);
  const [modelTitle, setModelTitle] = useState("Add Deficiency");
  const [deficiencyListData, setDeficiencyListData] = useState<
    DeficiencyInterface[]
  >([]);
  const [recommendationListData, setRecommendationListData] = useState<
    DeficiencyInterface[]
  >([]);
  const [inspectionConfig, setInspectionConfig] =
    useState<InspectionData | null>(null);

  const getDeficiencyData = () => {
    const params = {
      machine_id: state.machine_id,
      type: deficiencyTitle,
    };
    getDeficiencyDataAPI(params)
      .then((response) => {
        setDeficiencyListData(response);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const acknowledgementSchema = yup.object().shape({
    acknowledgement: yup
      .string()
      .required("acknowledgement is required")
      .min(1)
      .max(255),
  });

  const getRecommendationData = () => {
    const params = {
      machine_id: state.machine_id,
      type: recommendationTitle,
    };
    getDeficiencyDataAPI(params)
      .then((response) => {
        setRecommendationListData(response);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSubmit = (values) => {
    Swal.fire({
      title: "Please verify ",
      text: "You have fill all the correction dates",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: buttonColor.confirmButtonColor,
      cancelButtonColor: buttonColor.cancelButtonColor,
      color: buttonColor.color,
      confirmButtonText: "Yes, Submit it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deficiencyIssueDocumentAPI({ machine_id: state.machine_id })
          .then((response) => {
            setBtnLoading(false);
            toast.success(response.message);
            navigate(nameBasedProtectedRoutes.dashborad.path);
          })
          .catch((error) => {
            setBtnLoading(false);
          });
      }
    });
  };

  const getDeficiencyMachineData = () => {
    const machine_id = state.machine_id;
    getDeficiencyMachineAPI(machine_id)
      .then((response) => {
        setLoading(false);
        setInspectionConfig(response);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const correctionDateSubmit = (id, date) => {
    const formData: FormDataInterface = {
      id: id,
      correction_date: date, //moment(date).format("MM-DD-YYYY")
    };
    deficiencyCorrectionDate(formData)
      .then((response) => {
        setChangesState(!changesState);
      })
      .catch((error) => {
        setBtnLoading(false);
      });
  };

  useEffect(() => {
    getDeficiencyMachineData();
    getDeficiencyData();
    getRecommendationData();
  }, [changesState]);

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <section className="profile-main pt-4 dashboard-content">
      {loading ? (
        <Loader isLoading={loading} />
      ) : (
        <>
          <Container className="">
            <Row>
              <Col md={12} lg={12}>
                <Breadcrumb className="border-0 shadow-none mb-0">
                  <Breadcrumb.Item
                    className="fs-15 fw-semibold text-link"
                    href="Javascript:void(0)"
                    onClick={() =>
                      navigate(nameBasedProtectedRoutes.dashborad.path)
                    }
                  >
                    Dashboard
                  </Breadcrumb.Item>
                  <Breadcrumb.Item
                    className="fs-15 fw-semibold text-link"
                    href="Javascript:void(0)"
                    onClick={() =>
                      navigate(nameBasedProtectedRoutes.dashborad.path)
                    }
                  >
                    Inspection (SR-2212520) - Details
                  </Breadcrumb.Item>
                  <Breadcrumb.Item
                    active
                    className="fs-15 fw-semibold text-gray"
                  >
                    Recommendation/Deficiency Report
                  </Breadcrumb.Item>
                </Breadcrumb>
                <h1 className="fs-30 fw-bold mb-3 mt-2">
                  Recommendation/Deficiency Report
                </h1>
              </Col>
            </Row>
          </Container>
          <Container className="">
            <Row>
              <Col md={12} lg={12} className="">
                <Card className="border-0 mb-3 bg-none">
                  <Card.Body className="br-10 p-0 pt-2">
                    <div className="col-xl-12 mb-3 deficiency-box deficiency-box-border">
                      <Row>
                        
                        <Col md="3" className="mb-2">
                          <label className="fs-13 fw-bold">SR no.</label>
                          <div className="fs-15">
                            {inspectionConfig?.Inspection?.sr_number}
                          </div>
                        </Col>
                        <Col md="3" className="mb-2">
                          <label className="fs-13 fw-bold">Company</label>
                          <div className="fs-15">
                            {" "}
                            {inspectionConfig?.user?.company_name}
                          </div>
                        </Col>
                        <Col md="3" className="mb-2">
                          <label className="fs-13 fw-bold">
                            Inspection date
                          </label>
                          <div className="fs-15">
                            {" "}
                            {moment(
                              inspectionConfig?.Inspection?.inspection_date
                            ).format("MM-DD-YYYY")}
                          </div>
                        </Col>
                        <Col md="3" className="mb-2">
                          <label className="fs-13 fw-bold">Inspector</label>
                          <div className="fs-15">
                            {inspectionConfig?.Inspection?.inspector?.full_name}
                          </div>
                        </Col>
                        <Col md="3" className="mb-2">
                          <label className="fs-13 fw-bold">Device ID</label>
                          <div className="fs-15">
                            {" "}
                            {inspectionConfig?.device_id  && inspectionConfig?.device_id!='' ? inspectionConfig?.device_id :"-"}
                          </div>
                        </Col>
                        <Col md="3" className="mb-2">
                          <label className="fs-13 fw-bold">Make</label>
                          <div className="fs-15"> {inspectionConfig?.make}</div>
                        </Col>
                        <Col md="3" className="mb-2">
                          <label className="fs-13 fw-bold">Model</label>
                          <div className="fs-15">
                            {" "}
                            {inspectionConfig?.model_number}
                          </div>
                        </Col>
                        <Col md="3" className="mb-2">
                          <label className="fs-13 fw-bold">Serial</label>
                          <div className="fs-15">
                            {" "}
                            {inspectionConfig?.serial_number}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="col-xl-12 mb-3 deficiency-box">
                      <div className="row">
                        <div className="col-xl-12 mb-2">
                          <Row className="mb-3">
                            <Col
                              md="12"
                              className="align-items-center d-flex justify-content-between"
                            >
                              <h2 className="fs-20 fw-bold border-left-6 mb-0 text-uppercase ls-2">
                                DEFICIENCIES
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <p className="align-items-start mb-3">
                                (D) refers to{" "}
                                <b className="fw-bold">Deficiencies</b> in your
                                device that <b className="fw-bold">MUST</b> be
                                properly corrected prior to the issuance of a
                                certificate. Deficiencies must be corrected
                                within 90 days or re-inspection will be
                                required. Please indicate the date that
                                corrective action was completed.{" "}
                                <b className="fw-bold">SIGN</b> and{" "}
                                <b className="fw-bold">WITNESS</b> this page,
                                and return it to HESCO by mail, email, or fax.
                              </p>

                              <div className="defeciency-item-cover">
                                {deficiencyListData &&
                                  deficiencyListData.map((deficiency, key) => {
                                    return (
                                      <div
                                        key={key}
                                        className="d-md-flex justify-content-between mt-3"
                                      >
                                        <div className="fs-18">
                                          <b className="fw-bold">D{key + 1}</b>{" "}
                                          {deficiency.title}
                                        </div>
                                        <div className="defeciency-input-cover">
                                          <InputDatePicker
                                            controlId="correction date"
                                            label="correction date"
                                            placeholder="correction date"
                                            handleChange={(e) => {
                                              correctionDateSubmit(
                                                deficiency.id,
                                                e
                                              );
                                             
                                            }}
                                            value={deficiency.correction_date}
                                          />
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </Col>
                          </Row>
                        </div>

                        <div className="col-xl-12 mb-2">
                          <Row className="mb-3">
                            <Col
                              md="12"
                              className="align-items-center d-flex justify-content-between"
                            >
                              <h2 className="fs-20 fw-bold border-left-6 mb-0 text-uppercase ls-2">
                                OUR RECOMMENDATIONS
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <p className="align-items-start  mb-3">
                                (R) refers to{" "}
                                <b className="fw-bold">Recommendations</b>{" "}
                                relating to normal maintenance that can extend
                                the life of your device, that HESCO has made to
                                improve equipment utilization and safety.
                                Recommendations are{" "}
                                <b className="fw-bold">NOT</b> mandatory for
                                certification, but HESCO advises that
                                recommendations be addressed to minimize the
                                possibility of excessive wear or the development
                                of an unsafe condition.
                              </p>

                              <div className="defeciency-item-cover">
                                {recommendationListData &&
                                  recommendationListData.map(
                                    (recommendation, key) => {
                                      return (
                                        <div
                                          key={key}
                                          className="d-md-flex justify-content-between"
                                        >
                                          <div className="fs-18">
                                            <b className="fw-bold">
                                              {" "}
                                              R{key + 1}
                                            </b>{" "}
                                            {recommendation.title}
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className="col-xl-12 mb-2">
                          <p className="fs-15 mb-2">
                            Always follow manufacturer's requirements (i.e.e
                            re-torqueing turret bolts, sprag clutch exchange
                            etc.)
                          </p>
                          <p className="mb-3">
                            <b className="fs-15 ">
                              Sign and witness this page below by clicking the
                              blue boxes at the bottom of the page.
                            </b>
                          </p>
                          <Row>
                            <Col md="3">
                              <Signature
                                title="Click for Customer Signature"
                                heading="My Signature"
                                id={inspectionConfig?.deficiencyData?.id}
                                image={
                                  inspectionConfig?.deficiencyData
                                    ?.customer_signature
                                }
                                type="customer"
                                setChangesState={setChangesState}
                                changesState={changesState}
                              />
                            </Col>

                            <Col md="3">
                              <Signature
                                title="Click for Witness Signature"
                                heading="Witness Signature"
                                id={inspectionConfig?.deficiencyData?.id}
                                image={
                                  inspectionConfig?.deficiencyData
                                    ?.wittness_signature
                                }
                                type="witness"
                                setChangesState={setChangesState}
                                changesState={changesState}
                              />
                            </Col>
                          </Row>
                          <p className="fs-15 mb-2 mt-2">
                            If you are unable to sign the document below, you
                            may download, print, sign and email a copy of the
                            signed document to ed@hescocrane.com.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12 mt-3">
                      <Row className="mb-3">
                        <Col
                          md="12"
                          className="align-items-center d-flex justify-content-between"
                        >
                          <h2 className="fs-15 fw-bold  mb-0 ">
                            Acknowledgement
                          </h2>
                        </Col>
                        <Col>
                          <p>
                            {inspectionConfig?.deficiencyData?.acknowledgement}
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <div className="d-flex justify-content-end inspector-footer pt-3 pb-3 pe-3 ps-3">
                          <Container>
                            <Row>
                              <Col
                                sm="12"
                                className="d-flex justify-content-end"
                              >
                                <button
                                  type="reset"
                                  onClick={handleBack}
                                  className="me-2 fs-15 fw-semibold text-black btn btn-outline-secondary"
                                >
                                  Cancel
                                </button>
                                {btnLoading ? (
                                  <button
                                    className="fs-15 fw-semibold text-black btn btn-primary"
                                    type="submit"
                                  >
                                    <Spinner size="sm" />
                                  </button>
                                ) : inspectionConfig?.deficiencyData
                                    ?.customer_signature != null &&
                                  inspectionConfig?.deficiencyData
                                    ?.wittness_signature != null &&
                                  deficiencyListData.every(
                                    (item) => item.correction_date != null
                                  ) ? (
                                  <>
                                    {" "}
                                    <button
                                      className="fs-15 fw-semibold text-black btn btn-primary"
                                      onClick={handleSubmit}
                                    >
                                      Save & Submit
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <button
                                      className="fs-15 fw-semibold text-black btn btn-primary"
                                      disabled
                                    >
                                      Save & Submit
                                    </button>
                                  </>
                                )}
                              </Col>
                            </Row>
                          </Container>
                        </div>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </section>
  );
};
